const React = require('react');

// Logs when the client route changes
// exports.onClientEntry = () => {
// };
